export default "__VITE_ASSET__B4M$iY44__"